import {
	Box,
	TableCell,
	TableRow,
	Typography
} from "@mui/material";
import clsx from "clsx";
import { useTranslation } from 'react-i18next';
import { IRubricItem } from "@repositories/model/transfer/IRubricInfo";

type Props = {
	itemInfo: IRubricItem;
	variant?: 'default' | 'compact' | 'scoring';
	className?: string;
	classes?: any;
}

export const RubricItemRow = (props: Props) => {
	const { itemInfo, variant = 'default', className, classes } = props;
	const { t } = useTranslation();

	// variant에 따라 다른 레이아웃 렌더링
	if (variant === 'scoring') {
		return (
			<TableRow 
				sx={{
					'&:last-child .MuiTableCell-body': {}
				}}
				className={className}
			>
				<TableCell width='74%' align="center" className={classes?.rubricCell}>
					<Box display="flex" height="100%">
						<Box 
							display='flex' 
							alignItems='center' 
							justifyContent='center' 
							width="10.5%" 
							height="100%"
							sx={{ borderRight: '1px solid #cbcbcb' }}
						>
							<Typography width='100%'>{t(itemInfo.name)}</Typography>
						</Box>
						<Box 
							display='flex' 
							alignItems='center' 
							justifyContent='center' 
							width="11.5%" 
							height="100%"
							sx={{ borderRight: '1px solid #cbcbcb' }}
						>
							<Typography width='100%' className={classes?.markText}>
								<span>{itemInfo.score}</span>{t("점")}
							</Typography>
						</Box>
						<Box 
							width='80%' 
							height="100%"
							alignItems='center'
							justifyContent='center' 
							display='flex' 
							className={clsx(classes?.scoreMarkInput, classes?.scoreMarkInputMulti)}
						>
							<Typography width='100%' className={classes?.tableText} sx={{ textAlign: 'left', marginLeft: '5px' }}>
								{t(itemInfo.standard)}
							</Typography>
						</Box>
					</Box>
				</TableCell>
			</TableRow>
		);
	}

	// default와 compact 버전
	return (
		<TableRow className={className}>
			<TableCell width='10%' align="center" className={clsx(classes?.rubricScoreBgColor)}>
				<Typography>{itemInfo.name}</Typography>
			</TableCell>
			<TableCell width='10%' className={clsx(classes?.rubricScoreBgColor)}>
				<Typography className={clsx(classes?.markText, classes?.rubricText)}>
					<span>{itemInfo.score}</span>{t("점")}
				</Typography>
			</TableCell>
			<TableCell width='80%' align="left" className={classes?.borderLine}>
				<Box className={clsx(classes?.scoreMarkInput, classes?.scoreMarkInputMulti)}>
					<Typography className={classes?.tableText}>
						{itemInfo.standard}
					</Typography>
				</Box>
			</TableCell>
		</TableRow>
	);
};

